import { useMemo } from 'react';

import cn from 'classnames';

import { HKD, PRECISION } from '@constants/index'
import { getRate } from '@utils/getRate'
import helper from '@utils/helper';
import { useMarketStore } from '@widget/airdrop/hooks/useMarketStore';

import styles from './index.module.css';

export const useKLineHeader = (params) => {
  const { precision, coinDetail, midPrice, midPriceRise } = params;
  const marketStore = useMarketStore();
  const { coinDetail: rateDetail, otherRateDetail } = marketStore;
  const { value, priceClass, price } = useMemo(() => {
    const coinPriceLast = Number(rateDetail?.priceLast ?? 1);
    const otherPriceLast = Number(otherRateDetail?.priceLast ?? 1);
    const coinArr = coinDetail?.coinCode?.split('_') ?? [];
    const rateType = getRate();
    const prefix = rateType === HKD ? '≈HK$' : '≈$';
    const priceClass = cn(styles.normal, {
      [styles.rise]: Number(midPriceRise) > 0,
      [styles.fall]: Number(midPriceRise) < 0
    })

    const price = midPrice !== '--' ? helper.formatFixNumString(midPrice, precision) : '--'
    if (midPrice !== '--') {
      let midPriceNew;
      if (coinArr[1] === 'USDT') {
        midPriceNew = Number(midPrice) * coinPriceLast;
      } else if (coinArr[1] === rateType) {
        midPriceNew = Number(midPrice);
      } else {
        midPriceNew = Number(midPrice) / otherPriceLast * coinPriceLast
      }
      return {
        value: `${prefix}${helper.addCommaToThousands(helper.formatFixNumString(Number(midPriceNew), PRECISION))}`,
        priceClass,
        price
      }
    }
    return {
      value: `${prefix}--`,
      priceClass,
      price
    }
  }, [midPrice, midPriceRise, precision, rateDetail?.priceLast, otherRateDetail?.priceLast, coinDetail])

  console.log(value, 'valuevalue')
  const { riseAndFall, riseAndFallClass } = useMemo(() => {
    let prefix = '';
    if (Number(coinDetail?.riseAndFall ?? '0') > 0) {
      prefix = '+'
    }
    const riseAndFallClass = cn(styles.normal, {
      [styles.rise]: Number(coinDetail?.riseAndFall ?? '0') > 0,
      [styles.fall]: Number(coinDetail?.riseAndFall ?? '0') < 0
    })
    if (typeof coinDetail?.riseAndFall !== 'undefined') {
      return {
        riseAndFallClass,
        riseAndFall: `${prefix}${helper.formatFixNumString(Number(coinDetail?.riseAndFall), 2)}%`
      }
    }
    return {
      riseAndFallClass,
      riseAndFall: `${prefix}--%`
    }
  }, [coinDetail])
  const { highPrice, lowPrice, volume } = useMemo(() => {
    if (typeof precision === 'undefined' || !coinDetail) {
      return {
        highPrice: '--',
        lowPrice: '--',
        volume: '--'
      }
    }
    return {
      highPrice: `${helper.addCommaToThousands(helper.formatFixNumString(coinDetail.highPrice, precision))}`,
      lowPrice: `${helper.addCommaToThousands(helper.formatFixNumString(coinDetail.lowPrice, precision))}`,
      volume: helper.addCommaToThousands(helper.formatFixNumString(coinDetail.volume, 2))
    }
  }, [precision, coinDetail])
  return {
    value,
    price,
    priceClass,
    riseAndFall,
    riseAndFallClass,
    highPrice,
    lowPrice,
    volume
  }
}
